<script>
import './CustomButton.scss'

export default {
  props: {
    text: {
      type: String,
      required: false,
      default: null
    },
    StyleSheet: {
      type: String,
      required: false
    },
    type: {
      type: String,
      default: 'PrimaryButton',
      validator: value => [
        'PrimaryButton', 'OutlinedButton', 'IconButton', 'ErrorIconButton', 'ErrorButton'
      ].includes(value)
    },
    icon: {
      type: String,
      default: null,
      required: false
    },
    disabled: Boolean
  }
}
</script>

<template>
  <button :id="type" :style="StyleSheet" @click="$emit('click')" type="button" :disabled="disabled">
    <i :class="icon && text ? icon + ' mr-1 font-wt-4' : icon + ' font-wt-4'"></i> {{ text }}
  </button>
</template>



// WEBPACK FOOTER //
// src/components(new)/UI/Buttons/CustomButton/CustomButton.vue